import { coastalFloods } from "./coastal-floods";
import { earthquakes } from "./earthquakes";
import { hail } from "./hail";
import { heatWaves } from "./heat-waves";
import { hurricanes } from "./hurricanes";
import { iceStorm } from "./ice-storm";
import { landslides } from "./landslides";
import { riverineFloods } from "./riverine-floods";
import { strongWinds } from "./strong-winds";
import { tornadoes } from "./tornadoes";
import { wildfires } from "./wildfires";
import { winterWeather } from "./winter-weather";
/**
 * Object mapped to the same keys as @enum {NRIDataCategory} for consistency.
 */

export const nriLegends = {
  hurricanes: hurricanes,
  tornadoes: tornadoes,
  coastal_flooding: coastalFloods,
  earthquakes: earthquakes,
  riverine_flooding: riverineFloods,
  winter_weather: winterWeather,
  wildfires: wildfires,
  hail,
  landslides,
  ice_storm: iceStorm,
  strong_winds: strongWinds,
  heat_waves: heatWaves,
};
